import moment from 'moment';

export default function(event) {
    return moment(event.end_utc) < moment().subtract(1, 'months');
};
